var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.deliverableDetail,
          expression: "deliverableDetail"
        }
      ],
      ref: "rootTag",
      staticClass: "edit-osmp-deliverable-modal no-focus-visible-outline",
      class: _vm.deliverableDetail.permissions.viewOnly ? "read-only" : "",
      attrs: { tabindex: "-1" }
    },
    [
      _vm.isParentProjectOnHold(_vm.deliverableDetail.project_id)
        ? _c("div", { staticClass: "deliverable-project-on-hold-header" }, [
            _c("div", { staticClass: "icon-wrapper" }, [
              _c("img", {
                attrs: {
                  src: require("@/csmworkflow/img/project-on-hold-icon.svg")
                }
              })
            ]),
            _vm._v(" "),
            _c("h1", [
              _vm._v(
                "Project On Hold - " +
                  _vm._s(_vm.deliverableDetail.project_id.name)
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "departments__wrapper" },
        [
          _c("DeliverableDropdown", {
            attrs: {
              deliverable: _vm.deliverableDetail,
              deliverableTypes: _vm.deliverableTypes,
              classNames: "department-title",
              namespace: _vm.namespace
            }
          }),
          _vm._v(" "),
          _vm.showDepartment()
            ? _c("DeliverableDepartments", {
                attrs: {
                  deliverable: _vm.deliverableDetail,
                  namespace: _vm.namespace
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("DeliverableProjects", {
            attrs: {
              deliverable: _vm.deliverableDetail,
              namespace: _vm.namespace
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "plan-settings" },
        [
          _c(
            "div",
            { staticClass: "settings-header" },
            [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-toggle",
                      rawName: "v-b-toggle.collapse-social-plan-dialog",
                      modifiers: { "collapse-social-plan-dialog": true }
                    }
                  ],
                  staticClass: "plan-group-toggle"
                },
                [
                  _c("i", {
                    staticClass: "fas fa-chevron-right collapse-indicator"
                  })
                ]
              ),
              _vm._v(" "),
              _c("SocialMediaPlanTitle", {
                attrs: {
                  deliverableDetail: _vm.deliverableDetail,
                  showSocialPlanDetails: !_vm.showSocialPlanDetails,
                  deliverableTypes: _vm.deliverableTypes,
                  namespace: _vm.namespace
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.showSocialPlanDetails,
                      expression: "!showSocialPlanDetails"
                    }
                  ],
                  staticClass: "pb-0",
                  on: {
                    click: function($event) {
                      _vm.showSocialPlanDetails = !_vm.showSocialPlanDetails
                    }
                  }
                },
                [
                  _c("div", { staticClass: "group-title" }, [
                    _c(
                      "h1",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.editTitle,
                            expression: "!editTitle"
                          }
                        ],
                        staticClass: "mb-0 exclude-outside-click project-title"
                      },
                      [_vm._v(_vm._s(_vm.deliverableDetail.title))]
                    )
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-collapse",
            {
              staticClass: "settings-content-collapse",
              attrs: { id: "collapse-social-plan-dialog" },
              model: {
                value: _vm.showSocialPlanDetails,
                callback: function($$v) {
                  _vm.showSocialPlanDetails = $$v
                },
                expression: "showSocialPlanDetails"
              }
            },
            [
              _c(
                "div",
                { staticClass: "settings-content" },
                [
                  _c("SocialMediaPlanDialog", {
                    attrs: {
                      isEdit: _vm.showSocialPlanDetails,
                      hideTitle: true,
                      deliverableDetail: _vm.deliverableDetail,
                      namespace: _vm.namespace
                    }
                  })
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-tabs",
        {
          attrs: { card: "" },
          model: {
            value: _vm.activeDeliverableTab,
            callback: function($$v) {
              _vm.activeDeliverableTab = $$v
            },
            expression: "activeDeliverableTab"
          }
        },
        [
          _c(
            "b-tab",
            {
              staticClass: "b-tab-tasks",
              attrs: { title: "Tasks" },
              on: { click: _vm.onTabClick }
            },
            [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c(
                      "div",
                      { staticClass: "add-task-button-mobile" },
                      [
                        !(
                          !_vm.userAbilities.editMediaCall ||
                          _vm.deliverableDetail.permissions.viewOnly
                        )
                          ? _c(
                              "b-button",
                              {
                                staticClass: "add-task-btn",
                                attrs: { variant: "theme" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.createTask.apply(null, arguments)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              Add Task\n              "
                                ),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.addingTask,
                                        expression: "addingTask"
                                      }
                                    ],
                                    staticClass:
                                      "ml-2 spinner-border spinner-border-sm text-primary",
                                    attrs: { role: "status" }
                                  },
                                  [
                                    _c("span", { staticClass: "sr-only" }, [
                                      _vm._v("Loading...")
                                    ])
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("TaskFieldLabels", {
                      ref: "TaskFieldLabelsRef",
                      attrs: {
                        fullDeliverables: _vm.deliverableDetail,
                        deliverableId: _vm.deliverableDetail.deliverableId,
                        deliverable: _vm.deliverableDetail,
                        tasks: _vm.deliverableDetail.tasks,
                        namespace: _vm.namespace
                      }
                    }),
                    _vm._v(" "),
                    _c("TaskFields", {
                      attrs: {
                        fullDeliverables: _vm.deliverableDetail,
                        deliverableId: _vm.deliverableDetail.deliverableId,
                        deliverable: _vm.deliverableDetail,
                        tasks: _vm.deliverableDetail.tasks,
                        namespace: _vm.namespace
                      }
                    })
                  ],
                  1
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "b-tab",
            {
              staticClass: "b-tab-content-calendar",
              attrs: { title: "Content Calendar" },
              on: { click: _vm.onTabClick }
            },
            [
              _vm.deliverableDetail.deliverableId
                ? _c("RelatedDeliverablesGrouped", {
                    key: "eosmp-rdg",
                    ref: "refRelatedDeliverablesGrouped",
                    attrs: {
                      parentDeliverableId: _vm.deliverableDetail.deliverableId,
                      namespace: _vm.namespaceRelated,
                      tabTitle: "content-calendar",
                      pageCount: _vm.getPageCount
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-tab",
            {
              staticClass: "b-tab-scheduled-content",
              attrs: { title: "Scheduled Content", lazy: _vm.lazyLoadCalendar },
              on: { click: _vm.onTabClick }
            },
            [
              _vm.deliverableDetail.deliverableId
                ? _c("RelatedDeliverablesSchedule", {
                    key: "eosmp-rds",
                    ref: "refRelatedDeliverablesSchedule",
                    attrs: {
                      parentDeliverableId: _vm.deliverableDetail.deliverableId,
                      namespace: _vm.namespaceRelated,
                      tabTitle: "scheduled-content"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "responsive-edit-modal-controls",
          class: _vm.showModalOptions ? "open" : ""
        },
        [
          _c(
            "button",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.hover",
                  modifiers: { hover: true }
                }
              ],
              staticClass: "btn modal-more-controls",
              attrs: { title: "More options" },
              on: {
                click: function($event) {
                  _vm.showModalOptions = !_vm.showModalOptions
                }
              }
            },
            [
              _c("i", {
                staticClass: "fas",
                class: !_vm.showModalOptions
                  ? "fa-arrow-left"
                  : "fa-arrow-right"
              })
            ]
          ),
          _vm._v(" "),
          _vm.userAbilities.deleteMediaCall &&
          !_vm.deliverableDetail.permissions.viewOnly
            ? _c(
                "button",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover",
                      modifiers: { hover: true }
                    }
                  ],
                  staticClass: "btn delete-deliverable-btn",
                  attrs: { title: _vm.getDeleteDeliverableTitle },
                  on: {
                    click: function($event) {
                      return _vm.removeDeliverable(
                        _vm.deliverableDetail.deliverableId
                      )
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-trash-alt" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("DuplicateMediaCallBtn", {
            attrs: {
              deliverableId: _vm.deliverableDetail.deliverableId,
              namespace: _vm.namespace,
              deliverableTemplateId:
                _vm.deliverableDetail.deliverable_template_id
            }
          }),
          _vm._v(" "),
          _c("FeedbackBtn"),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.hover",
                  modifiers: { hover: true }
                }
              ],
              staticClass: "btn close-deliverable-btn",
              attrs: { title: "Close" },
              on: { click: _vm.onCloseModal }
            },
            [_c("i", { staticClass: "fas fa-times" })]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            type: "warn",
            title: "Confirm Deletion",
            "ok-title": "Yes, Delete"
          },
          on: { ok: _vm.onConfirmRemoveDeliverable },
          model: {
            value: _vm.showRemoveDeliverable,
            callback: function($$v) {
              _vm.showRemoveDeliverable = $$v
            },
            expression: "showRemoveDeliverable"
          }
        },
        [_c("p", [_vm._v("Are you sure you want to delete this deliverable?")])]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "modal-edit-social-deliverable",
          attrs: {
            size: "lg",
            "no-close-on-backdrop": "",
            "hide-footer": "",
            id: "editRelatedSocialModal",
            title: "Edit Related Social Deliverable",
            "no-close-on-esc": ""
          },
          on: {
            show: _vm.editSocialModalShown,
            shown: _vm.afterEditSocialModalShown,
            hide: _vm.editSocialModalHidden,
            hidden: _vm.removeRoute
          }
        },
        [
          _c("EditSocialModal", {
            ref: "refEditRelatedSocialModal",
            attrs: {
              allContacts: _vm.allContacts,
              tabIndex: _vm.socialModalTabIndex,
              namespace: _vm.namespaceRelated
            },
            on: { modalDetailUpdated: _vm.pushRoute }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }